import { GoogleTagManagerHeadTag, GoogleTagManagerBodyTag } from 'cio/utils/tracking-scripts/google-tag-manager';
import { TrackingScript, TrackingContext } from 'cio/utils/tracking-scripts/types';

const SCRIPTS = [GoogleTagManagerHeadTag, GoogleTagManagerBodyTag];

const tracking = {
  injectedScriptIds: new Set<string>(),

  onAppLoad(ctx: TrackingContext) {
    SCRIPTS.forEach((script) => tracking._inject(script, ctx));
  },

  _inject(script: TrackingScript, ctx: TrackingContext) {
    if (tracking.injectedScriptIds.has(script.id)) {
      tracking._remove(script, ctx);
    }

    tracking.injectedScriptIds.add(script.id);
    script.inject(tracking._build(script), ctx);
  },

  _build(script: TrackingScript) {
    let el = document.createElement(script.tag);
    el.id = script.id;
    if (script.type != null) {
      el.setAttribute('type', script.type);
    }
    el.innerHTML = script.content;

    return el;
  },

  _remove(script: TrackingScript, ctx: TrackingContext) {
    script.cleanup?.(ctx);

    let el = document.getElementById(script.id);
    if (el) {
      el.parentNode?.removeChild(el);
    }
  },
};

export default tracking;
